<template>
  <el-row>
    <el-row class="BannerContWidth">
      <el-col :span="24">
        <el-col :span="16"
                :xs='24'>
          <div class="DetailsCont">
            <div class="gameBox"
                 v-for="(item, index) in allGameList"
                 :key="index"
                 @click="ToProduct(item.game_id)">
              <div class="gamelogo">
                <img :src="item.logo_url">
              </div>
              <div class="gameInfo">
                <span class="tricon"></span>
                <span class="tricon-text">{{index+1}}</span>
                <p class="title">{{item.game_name}}</p>
                <p class="agent">{{item.issuer}}</p>
                <p class="info">{{item.description}}</p>
              </div>
              <div class="gameImg">
                <img :src="item.preview_url[0]">
              </div>
            </div>
          </div>
        </el-col>
        <el-col :md="{span: 7,offset: 1}"
                :sm="{span: 8,offset: 0}"
                class="hidden-xs-only">
          <QRCode></QRCode>
        </el-col>
      </el-col>
    </el-row>
    <foot></foot>
  </el-row>
</template>

<script>
import QRCode from '@/components/QRCode'
import foot from '@/components/foot'
export default {
  name: 'product',
  components: {
    QRCode,
    foot
    // VueScrollbar
  },
  data () {
    return {
      allGameList: []
    }
  },
  created () {
    this.gameListData();
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    gameListData () { // 获取游戏列表
      this.$axios.get(this.apiUrl.API.GameList)
        .then((res) => {
          res.data.data.forEach(element => {
            element.preview_url = element.preview_url.split(',')
          });
          this.allGameList = res.data.data
        })
    },
    ToProduct (id) { // 跳转游戏详情
      this.$router.push({
        path: `/product?id=${id}`
      })
    }
  },
  updated () { }
}
</script>

<style lang="less" scoped>
.BannerContWidth {
  width: 1040px;
  display: flex;
  margin: 0 auto;
}
.DetailsCont {
  width: 100%;
  margin: 1.5rem 0;
}
.gameBox {
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  overflow: hidden;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
  background: #fff;
  word-wrap: break-word;
  /* 角标 */
  .tricon {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    border-top: 50px solid #ffcc25;
    border-right: 50px solid transparent;
  }
  /* 角标内数字 */
  .tricon-text {
    display: block;
    position: absolute;
    top: 5px;
    left: 0;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    font: italic 18px Impact;
    color: #fff;
    z-index: 10;
    word-break: normal;
    word-wrap: normal;
  }
  .gamelogo {
    max-width: 128px;
    max-height: 128px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 2rem;
    }
  }
  .gameInfo {
    max-width: 256px;
    max-height: 130px;
    margin: 0 20px;
    p {
      text-align: left;
    }
    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 20px;
      color: #101010;
    }
    .agent {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin: 4px 0;
      font-size: 12px;
      color: rgba(16, 16, 16, 0.48);
    }
    .info {
      display: -webkit-box;
      -webkit-line-clamp: 4;
      overflow: hidden;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      text-align: justify;
      font-size: 14px;
    }
  }
  .gameImg {
    width: 316px;
    max-height: 175px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
@media (max-width: 1200px) {
  .BannerContWidth {
    width: 88%;
  }
}
@media (max-width: 992px) {
  .BannerContWidth {
    width: 84%;
  }
}
@media (max-width: 768px) {
  .BannerContWidth {
    width: 82%;
  }
}
@media (max-width: 576px) {
  .BannerContWidth {
    width: 100%;
  }
  .gameBox {
    padding: 10px;
    margin-bottom: 0;
    box-shadow: none;
    border-bottom: 1px solid #eee;
    justify-content: flex-start;
    .gamelogo {
      max-width: 60px;
      max-height: 60px;
      img {
        border-radius: 1rem;
      }
    }
    .gameInfo {
      .tricon {
        display: none;
      }
      .tricon-text {
        display: none;
      }
      .title {
        font-size: 14px;
      }
      .agent {
        display: none;
      }
      .info {
        display: none;
      }
    }
    .gameImg {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/allGames.vue